export const RESTORE_PASSWORD_TEXTS = {
    TOAST_MESSAGES: {
        EMAIL_REQUIRED: "Se requiere el email",
        NOT_REGISTERED: "No estás registrado en Wuuju. ¿Es un error? Comunicate con nosotros a WhatsApp",
        EMAIL_NOT_SENT: "No se logró enviar el correo de recuperación. Comunicate con nosotros por Whatsapp."
    },
    MAIN_TITLE: "¿Tienes problemas para iniciar sesión?",
    BUTTON_LABEL: "Enviar enlace de recuperación",

    OR_TEXT: "O",
    CREATE_ACCOUNT_TEXT: "Crea una nueva Wuuju-cuenta, es gratis",
    BACK_TO_LOGIN_TEXT: "Volver al inicio de sesión",
    MODAL_TITLE: "Correo electrónico enviado",
    MODAL_BUTTON_TEXT: "Aceptar"
};